"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Image = void 0;
var jsx_runtime_1 = require("react/jsx-runtime");
var react_1 = require("react");
var ajoneuvoni_placeholder_1_png_1 = __importDefault(require("../../images/ajoneuvoni-placeholder-1.png"));
var AJONEUVONI_TUNNUS_RGB_Small_png_1 = __importDefault(require("../../images/AJONEUVONI_TUNNUS_RGB_Small.png"));
var image_url_1 = require("../utils/image-url");
var Image = function (_a) {
    var src = _a.src, h = _a.h, w = _a.w, className = _a.className, placeholderType = _a.placeholderType;
    var _b = (0, react_1.useState)(''), localSrc = _b[0], setSrc = _b[1];
    (0, react_1.useEffect)(function () {
        var s = ajoneuvoni_placeholder_1_png_1.default;
        if (placeholderType === 'thumbnail')
            s = AJONEUVONI_TUNNUS_RGB_Small_png_1.default;
        if (src) {
            s = (0, image_url_1.imageUrl)(src, w);
        }
        setSrc(s);
    }, [src, h, w, placeholderType]);
    return (0, jsx_runtime_1.jsx)("img", { src: localSrc, alt: "car", className: className });
};
exports.Image = Image;
